import { useDataChange, useDataValue } from 'Simple/Data'

export default function useDataOnChange(props) {
  let selected = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!value) return
    if (value.length === 0) return
    if (selected.id && value.some(item => item.id === selected.id)) {
      return
    }

    change({
      ...((selected.xid && value.find(item => item.xid === selected.xid)) ||
        value[0]),
      location_id: null,
    })
  }
}
